import React from "react";
import Navbar from "../../../navbar";
import Footer from "../../../footer";
import "./style.scss";
// import IpLocation from "ip-location";
// import axios from "axios";
import SEO from "../../../seo";

import { Link } from "gatsby";

import blogData from "../../../bloginner/data";

// import banner from "../../../../images/memoryfoamvslatexfoam.png";

export default function BenefitsOfMemoryFoam(props) {
  const { location, data } = props;

  //   const { blogImg, blogTitle, content, date, seoDescription, seoImg } = data;

  var prev = null;
  var next = null;

  let i = 0;

  blogData.forEach((item, it) => {
    if (location.pathname.includes(item.link)) {
      i = it;
    }
  });

  if (i === 0) {
    prev = null;
  } else {
    prev = (
      <Link className="blog__bottombuttons__prev" to={blogData[i - 1].link}>
        <i class="fas fa-arrow-left"></i> Prev
      </Link>
    );
  }

  if (i === blogData.length - 1) {
    next = null;
  } else {
    next = (
      <Link className="blog__bottombuttons__next" to={blogData[i + 1].link}>
        Next <i class="fas fa-arrow-right"></i>
      </Link>
    );
  }

  return (
    <div className="blog benefitsofmemoryfoam">
      <SEO
        title={"Benefits Of Memory Foam | Eclipse International"}
        description={
          "Explore the advantages and disadvantages of different mattress spring systems to make the best choice amongst Eclipse's wide range of spring mattresses."
        }
        img={""}
      />
      <Navbar />
      <div className="blog__content">
        <h1 className="blog__title">Benefits Of Memory Foam</h1>
        <div className="blog__header">
          <div className="blog__header__date">December 17, 2021</div>
          <div className="blog__header__socialshare">
            Share&nbsp; &nbsp;
            <span className="hicon">
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-facebook-f"></i>
              </a>
            </span>
            <span className="hicon">
              <a
                href={`https://twitter.com/intent/tweet?url=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-twitter"></i>
              </a>
            </span>
            <span className="hicon">
              <a
                href={`https://www.linkedin.com/sharing/share-offsite/?url=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-linkedin-in"></i>
              </a>
            </span>
          </div>
        </div>
        <img
          className="blog__headerimg blog__headerimg--desktop"
          src={
            "https://eclipsemattress.in/assets/blog/benefitsofmemoryfoam-banner-desktop.jpg"
          }
          alt="Blog Header Image"
        ></img>
        <img
          className="blog__headerimg blog__headerimg--mobile"
          src={
            "https://eclipsemattress.in/assets/blog/benefitsofmemoryfoam-banner-mobile.jpg"
          }
          alt="Blog Header Image"
        ></img>

        <div className="blog__container">
          <p>
            First designed in the mid-1960s for NASA spaceship seats, the
            shock-absorbing and pressure relieving qualities of{" "}
            <a href="/memory-foam/">Memory Foam</a> have till date continued to
            wow the industry.
            <br />
          </p>
          <div className="row">
            <div className="col col-12 col-xl-6">
              <div className="benefitsofmemoryfoam__card">
                <img src="https://eclipsemattress.in/assets/blog/memory-foam-icon3.png"></img>
                <div>
                  <h4>Pressure Relieving</h4>
                  <p>
                    Memory foam works on pressure points to provide relief from
                    pain and stress. It takes the shape of the body and helps
                    maintain posture further ensuring a comfortable and healthy
                    sleep.
                  </p>
                </div>
              </div>
            </div>

            <div className="col col-12 col-xl-6">
              <div className="benefitsofmemoryfoam__card">
                <img src="https://eclipsemattress.in/assets/blog/memory-foam-icon2.png"></img>
                <div>
                  <h4>Anti Allergen</h4>
                  <p>
                    It’s composed of Polyurethane foam which repels mold &
                    mildew and is resistant to pet dander. Due to its dense
                    structure, memory foam leaves no space for the dust to
                    accumulate.
                  </p>
                </div>
              </div>
            </div>

            <div className="col col-12 col-xl-6">
              <div className="benefitsofmemoryfoam__card">
                <img src="https://eclipsemattress.in/assets/blog/memory-foam-icon4.png"></img>
                <div>
                  <h4>Temperature Sensitive</h4>

                  <p>
                    It adjusts to the sleeper’s body heat and weight to ensure
                    sound sleep. A gel based memory foam actively absorbs and
                    releases heat from the body.
                  </p>
                </div>
              </div>
            </div>
            <div className="col col-12 col-xl-6">
              <div className="benefitsofmemoryfoam__card">
                <img src="https://eclipsemattress.in/assets/blog/memory-foam-icon1.png"></img>
                <div>
                  <h4>Durable</h4>
                  <p>
                    It is a durable material as it was originally designed for
                    NASA airplane seats. It can endure high pressure without
                    being damaged extensively.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <p>
            <a href="/memory-foam/">Memory foam</a> helps the mattress cushion
            the body evenly, and molds to the body in response to heat and
            pressure. Once pressure is removed, memory foam bounces back very
            slowly and over time it remembers the body shape and optimal
            sleeping position, justifying the name ‘memory’.
            <br />
            <br />
          </p>
          <br />
          <br />
        </div>

        <center>
          <div className="blog__header__socialshare">
            Share &nbsp; &nbsp;
            <span className="hicon">
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-facebook-f"></i>
              </a>
            </span>
            <span className="hicon">
              <a
                href={`https://twitter.com/intent/tweet?url=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-twitter"></i>
              </a>
            </span>
            <span className="hicon">
              <a
                href={`https://www.linkedin.com/sharing/share-offsite/?url=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-linkedin-in"></i>
              </a>
            </span>
          </div>
        </center>

        <div className="blog__bottombuttons">
          {prev} {next}
        </div>
      </div>
      <br />
      <br />
      <br />
      <Footer />
    </div>
  );
}
